(() => {
  const ownScript = document.currentScript || [...document.scripts].reverse().find((script) => /bed-maintenance-package\.js(?:\?|$)/.test(script.src));
  const currentSrc = ownScript?.src || '';
  const coreSrc = currentSrc.replace(/bed-maintenance-package\.js(?:\?.*)?$/, 'bed-maintenance-package-core.js');

  const ADDONS = Object.freeze({
    nightstandGeneric: 65601001226589,
    nightstandVerdoBeige: 65593425002845,
    nightstandVerdoTaupe: 65593425068381,
    maintenance: 65593463865693,
    disposal: 65593463767389,
  });

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const money = (value) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(Number(value) || 0);

  const parseProperties = (formData) => {
    const properties = {};
    for (const [key, rawValue] of formData.entries()) {
      const match = String(key).match(/^properties\[(.+)\]$/);
      if (!match) continue;
      const name = match[1];
      if (name === 'Bed Protect' || name === 'All-in-House Service') continue;
      const value = String(rawValue || '').trim();
      if (value) properties[name] = value;
    }
    return properties;
  };

  const getProperty = (formData, name) => String(formData.get(`properties[${name}]`) || '').trim();

  const getNightstandCount = (formData, flow) => {
    const property = normalize(getProperty(formData, 'Nachtkastjes'));
    if (/^2\b/.test(property) || property.includes('2 bijpassende')) return 2;
    if (/^1\b/.test(property) || property.includes('1 bijpassend')) return 1;
    if (flow?.querySelector('[data-verdo-choice="nightstand:two"].is-selected')) return 2;
    if (flow?.querySelector('[data-verdo-choice="nightstand:one"].is-selected')) return 1;
    return 0;
  };

  const hasMaintenance = (formData, flow) => {
    const property = normalize(getProperty(formData, 'Onderhoudspakket'));
    if (property.includes('inclusief')) return true;
    return Boolean(flow?.querySelector('[data-maintenance-choice="inclusive"].is-selected,[data-signature-maintenance="inclusive"].is-selected'));
  };

  const hasDisposal = (formData, flow) => {
    const property = normalize(
      getProperty(formData, 'Oude bed meenemen & afvoeren') ||
      getProperty(formData, 'Oude bed afvoeren')
    );
    if (property === 'ja' || property.startsWith('ja ')) return true;
    return Boolean(flow?.querySelector('[data-signature-disposal="yes"].is-selected,[data-disposal-choice="Ja"].is-selected'));
  };

  const hasMontage = (formData, flow) => {
    const property = normalize(getProperty(formData, 'Montage'));
    if (property && !property.includes('nog niet gekozen')) return true;
    return Boolean(flow?.querySelector('[data-verdo-choice="montage:free"].is-selected,[data-verdo-choice="montage:self"].is-selected'));
  };

  const getNightstandVariant = (handle) => {
    if (handle === 'dreamhouse-verdo-boxspring-met-opbergruimte-beige') return ADDONS.nightstandVerdoBeige;
    if (handle === 'dreamhouse-verdo-boxspring-met-opbergruimte-taupe') return ADDONS.nightstandVerdoTaupe;
    return ADDONS.nightstandGeneric;
  };

  const getCurrentVariantAmount = (picker, productInfo) => {
    try {
      const json = picker.querySelector('[data-selected-variant]')?.textContent;
      const variant = json ? JSON.parse(json) : null;
      const cents = Number(variant?.price);
      if (Number.isFinite(cents) && cents >= 0) return cents / 100;
    } catch (_) {}

    const priceText = productInfo.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular')?.textContent || '';
    const cleaned = priceText.replace(/[^0-9,.]/g, '');
    if (!cleaned) return 0;
    if (cleaned.includes(',')) return Number(cleaned.replace(/\./g, '').replace(',', '.')) || 0;
    return Number(cleaned) || 0;
  };

  const showError = (productInfo, message) => {
    let box = productInfo.querySelector('.verdo-validation');
    if (!box) {
      box = document.createElement('div');
      box.className = 'verdo-validation';
      const total = productInfo.querySelector('.verdo-sticky-total');
      const buttons = productInfo.querySelector('.product-form__buttons');
      if (total?.parentNode) total.parentNode.insertBefore(box, total);
      else if (buttons?.parentNode) buttons.parentNode.insertBefore(box, buttons);
      else productInfo.appendChild(box);
    }
    box.textContent = message;
    box.hidden = false;
  };

  const clearError = (productInfo) => {
    const box = productInfo.querySelector('.verdo-validation');
    if (box) box.hidden = true;
  };

  const setLoading = (form, loading) => {
    const button = form.querySelector('[type="submit"]');
    if (!button) return;
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      button.querySelector('.loading__spinner')?.classList.remove('hidden');
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      button.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  };

  const correctConfigurator = (picker) => {
    if (!picker) return;
    const productInfo = picker.closest('product-info');
    if (!productInfo) return;
    const flow = productInfo.querySelector('.verdo-options-flow');
    const form = productInfo.querySelector('product-form form[action*="/cart/add"]');
    if (!flow || !form) return;

    const onePrice = flow.querySelector('[data-verdo-choice="nightstand:one"] small');
    const twoPrice = flow.querySelector('[data-verdo-choice="nightstand:two"] small');
    if (onePrice) onePrice.textContent = '+ €199,00';
    if (twoPrice) twoPrice.textContent = '+ €398,00';

    const handle = picker.dataset.productHandle || '';
    if (/^adore-/.test(handle) || picker.dataset.adoreConfigurator === 'true') return;

    const formData = new FormData(form);
    const extras = (getNightstandCount(formData, flow) * 199)
      + (hasMaintenance(formData, flow) ? 99.95 : 0)
      + (hasDisposal(formData, flow) ? 125 : 0);
    const output = productInfo.querySelector('[data-verdo-total]');
    if (output) output.textContent = money(getCurrentVariantAmount(picker, productInfo) + extras);
  };

  const scheduleCorrection = (scope = document) => {
    [0, 120, 320, 800, 1400].forEach((delay) => {
      setTimeout(() => {
        const picker = scope.querySelector?.('variant-selects[data-bed-configurator="true"]') || document.querySelector('variant-selects[data-bed-configurator="true"]');
        correctConfigurator(picker);
      }, delay);
    });
  };

  if (!window.__nachtcomfortBedCartPricingBound) {
    window.__nachtcomfortBedCartPricingBound = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const productForm = form.closest('product-form');
      if (!productForm) return;
      const productInfo = form.closest('product-info');
      const picker = productInfo?.querySelector('variant-selects[data-bed-configurator="true"]');
      if (!productInfo || !picker) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.ncBedCartBusy === 'true') return;

      const formData = new FormData(form);
      const flow = productInfo.querySelector('.verdo-options-flow');
      clearError(productInfo);

      if (!hasMontage(formData, flow)) {
        showError(productInfo, 'Kies eerst Gratis montage of Zelf monteren.');
        flow?.querySelector('[data-verdo-step="montage"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const variantId = Number(formData.get('id'));
      const quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
      if (!Number.isFinite(variantId) || variantId <= 0) {
        showError(productInfo, 'De gekozen uitvoering kon niet worden toegevoegd. Kies de afmeting opnieuw.');
        return;
      }

      const productTitle = picker.dataset.productTitle || document.querySelector('.product__title h1')?.textContent?.trim() || 'Bed';
      const parentProperties = parseProperties(formData);
      const addonProperties = { '_Configuratie bij': productTitle, '_nc_addon': 'true' };
      const items = [{ id: variantId, quantity, properties: parentProperties }];

      const nightstandCount = getNightstandCount(formData, flow);
      if (nightstandCount > 0) {
        items.push({
          id: getNightstandVariant(picker.dataset.productHandle || ''),
          quantity: nightstandCount * quantity,
          properties: { ...addonProperties, '_Keuze': `${nightstandCount} nachtkastje${nightstandCount === 1 ? '' : 's'}` },
        });
      }

      if (hasMaintenance(formData, flow)) {
        items.push({
          id: ADDONS.maintenance,
          quantity,
          properties: { ...addonProperties, '_Keuze': 'Onderhoudspakket + 5 jaar service & garantie' },
        });
      }

      if (hasDisposal(formData, flow)) {
        items.push({
          id: ADDONS.disposal,
          quantity,
          properties: { ...addonProperties, '_Keuze': 'Oude bed meenemen & afvoeren' },
        });
      }

      form.dataset.ncBedCartBusy = 'true';
      setLoading(form, true);

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items }),
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || payload?.status) {
          throw new Error(payload?.description || payload?.message || 'Toevoegen aan winkelwagen mislukt.');
        }
        window.location.assign(window.routes?.cart_url || `${root}cart`);
      } catch (error) {
        form.dataset.ncBedCartBusy = 'false';
        setLoading(form, false);
        showError(productInfo, error?.message || 'Toevoegen aan winkelwagen mislukt. Probeer het opnieuw.');
      }
    }, true);

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.verdo-options-flow')) return;
      scheduleCorrection(document);
    }, true);

    document.addEventListener('change', (event) => {
      if (!event.target.closest('product-info')) return;
      scheduleCorrection(document);
    }, true);

    document.addEventListener('shopify:section:load', (event) => scheduleCorrection(event.target));
    document.addEventListener('shopify:section:select', (event) => scheduleCorrection(event.target));
  }

  const loadCore = () => {
    if (!coreSrc || coreSrc === currentSrc) {
      scheduleCorrection(document);
      return;
    }
    const script = document.createElement('script');
    script.src = `${coreSrc}${coreSrc.includes('?') ? '&' : '?'}nccore=${Date.now()}`;
    script.async = false;
    script.onload = () => scheduleCorrection(document);
    document.head.appendChild(script);
  };

  loadCore();
  scheduleCorrection(document);
})();
